import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "writeMessage";
const initialState = createInitialState();
const reducers = createReducers()
const extraActions = createExtraActions();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports

export const writeMessageActions = { ...slice.actions, ...extraActions };
export const writeMessageReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    creditBalance: {},
    categorycreditBalance: {},
    sendMessageStatus: null,
    ecardImages: null,
    ecardCategoryList: [],
    ecardList: [],
    ecardInfo: [],
    inmateList: [],
    ecardInmateInfo: [],
    sendEcardStatus: null,
    selectedCategories: [],
  };
}

function createExtraActions() {
  const keywordURL = `${process.env.REACT_APP_API_URL}/PublicUser/WriteMessage`;
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/WriteMessage`;
  const ecardUrl = `${process.env.REACT_APP_API_URL}/PublicUser/PublicEcard`;

  return {
    getCreditBalance: getCreditBalance(),
    getCategoryPublicCreditBalance: getCategoryPublicCreditBalance(),
    InsertUpdateMessageCommunicationSent:
      InsertUpdateMessageCommunicationSent(),
    LoadSendNotificationandEmail: LoadSendNotificationandEmail(),
    InsertUpdatePhotoCommunicationSent: InsertUpdatePhotoCommunicationSent(),
    InsertUpdateEcardCommunicationSent: InsertUpdateEcardCommunicationSent(),
    DraftMessageCUD: DraftMessageCUD(),
    GetDraftMessageDetails: GetDraftMessageDetails(),
    LoadECard: LoadECard(),
    LoadKeywordList: LoadKeywordList(),
    LoadEcardCategoryList: LoadEcardCategoryList(),
    LoadEcardList: LoadEcardList(),
    LoadEcardForPublicUserDetails: LoadEcardForPublicUserDetails(),
    LoadPublicMyContactsDisplayEcard: LoadPublicMyContactsDisplayEcard(),
    LoadPublicMyContactsDisplayForEcardDetails: LoadPublicMyContactsDisplayForEcardDetails(),
    SendEcardFromPublicUser: SendEcardFromPublicUser(),
  };

  // Action used for get cate credit balance
  function getCategoryPublicCreditBalance() {
    return createAsyncThunk(
      `${name}/CategoryPublicCreditBalance`,
      async ({ userId, inmatesId, CategoryId }) =>
        await fetchWrapper.post(
          `${baseUrl}/CategoryPublicCreditBalance?userId=${userId}&inmateId=${inmatesId}&CategoryId=${CategoryId}`
        )
    );
  }

  // Action used for get credit balance
  function getCreditBalance() {
    return createAsyncThunk(
      `${name}/PublicCreditBalance`,
      async ({ userId, inmatesId }) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicCreditBalance?userId=${userId}&inmateId=${inmatesId}`
        )
    );
  }

  // Action Used - Insert/ Update - Public user send (Message)
  function InsertUpdateMessageCommunicationSent() {
    return createAsyncThunk(
      `${name}/InsertUpdateMessageCommunicationSent`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/InsertUpdateMessageCommunicationSent`,
          data
        )
    );
  }

  // send mail and Notification (Message)
  function LoadSendNotificationandEmail() {
    return createAsyncThunk(
      `${name}/SendNotificationandEmail`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/SendNotificationandEmail`,
          data
        )
    );
  }

  // Action Used - Insert/ Update - Public user send (Photo)
  function InsertUpdatePhotoCommunicationSent() {
    return createAsyncThunk(
      `${name}/InsertUpdatePhotoCommunicationSent`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/InsertUpdatePhotoCommunicationSentFolderPath`,
          data
        )
    );
  }

  // Action Used - Insert/ Update - Public user send (Ecard)
  function InsertUpdateEcardCommunicationSent() {
    return createAsyncThunk(
      `${name}/InsertUpdateEcardCommunicationSent`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/InsertUpdateEcardCommunicationSent`,
          data
        )
    );
  }

  // Action used - save message as draft
  function DraftMessageCUD() {
    return createAsyncThunk(
      `${name}/DraftMessageCUD`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/DraftMessageCUD`, data)
    );
  }

  // GetDraftMessageDetails

  function GetDraftMessageDetails() {
    return createAsyncThunk(
      `${name}/GetDraftMessageDetails`,
      async ({ DraftID }) =>
        await fetchWrapper.post(
          `${baseUrl}/GetDraftMessageDetails?DraftID=${DraftID}`
        )
    );
  }

  function LoadECard() {
    return createAsyncThunk(
      `${name}/LoadECard`,
      async (data) => await fetchWrapper.post(`${baseUrl}/LoadECard`, data)
    );
  }

  // function LoadKeywordList() {
  //   return createAsyncThunk(
  //     `${name}/LoadCategoryDropDown`,
  //     async (data) =>
  //       await fetchWrapper.post(`${keywordURL}/LoadCategoryDropDown`, data)
  //   );
  // }

  function LoadKeywordList() {
    return createAsyncThunk(
      `${name}/LoadPuKeywordList`,
      async (data) =>
        await fetchWrapper.post(
          `${ecardUrl}/LoadPuKeywordList`,
          data
        )
    );
  }

  // Get E-card : Category List
  function LoadEcardCategoryList() {
    return createAsyncThunk(
      `${name}/LoadCategoryDropDown`,
      async () => await fetchWrapper.post(`${ecardUrl}/LoadCategoryDropDown`)
    );
  }

  // Get E-card : Images List
  function LoadEcardList() {
    return createAsyncThunk(
      `${name}/LoadEcardForPublicUser`,
      async (data) =>
        await fetchWrapper.post(`${ecardUrl}/LoadEcardForPublicUser`, data)
    );
  }

  // LoadEcardForPublicUserDetails
  function LoadEcardForPublicUserDetails() {
    return createAsyncThunk(
      `${name}/LoadEcardForPublicUserDetails`,
      async (ecardID) => {
        const response = await fetchWrapper.post(
          `${ecardUrl}/LoadEcardForPublicUserDetails?ecardId=${ecardID}`
        );
        return response; // 👈 Return the data here
      }
    );
  }

  // Load: Inmate List -----------------------------------------------
  function LoadPublicMyContactsDisplayEcard() {
    return createAsyncThunk(
      `${name}/LoadPublicMyContactsDisplayEcard`,
      async (data) =>
        await fetchWrapper.post(`${ecardUrl}/LoadPublicMyContactsDisplayEcard`, data)
    );
  }

  // E-card : Select Inmate based Load Available Credits/ (Facility Cost/ category Cost )
  function LoadPublicMyContactsDisplayForEcardDetails() {
    return createAsyncThunk(
      `${name}/LoadPublicMyContactsDisplayForEcardDetails`,
      async (data) =>
        await fetchWrapper.post(`${ecardUrl}/LoadPublicMyContactsDisplayForEcardDetails`, data)
    );
  }


  // Send E-card 
  function SendEcardFromPublicUser() {
    return createAsyncThunk(
      `${name}/SendEcardFromPublicUser`,
      async (data) =>
        await fetchWrapper.post(`${ecardUrl}/SendEcardFromPublicUser`, data)
    );
  }
}

function createReducers() {
  return {
    setSelectedCategories,
    clearSelectedCategories,
  }

  function setSelectedCategories(state, action) {
    state.selectedCategories = action.payload;
  }

  function clearSelectedCategories(state) {
    state.selectedCategories = [];
  }
}

function createExtraReducers(builder) {
  builder

    // Reducer for - get credit balance
    .addCase(extraActions.getCreditBalance.pending, (state) => {
      state.creditBalance = { loading: true };
    })
    .addCase(extraActions.getCreditBalance.fulfilled, (state, action) => {
      state.creditBalance = action.payload;
    })
    .addCase(extraActions.getCreditBalance.rejected, (state, action) => {
      state.creditBalance = { error: action.error };
    })

    // Reducer for - get credit balance
    .addCase(extraActions.getCategoryPublicCreditBalance.pending, (state) => {
      state.categorycreditBalance = { loading: true };
    })
    .addCase(extraActions.getCategoryPublicCreditBalance.fulfilled, (state, action) => {
      state.categorycreditBalance = action.payload;
    })
    .addCase(extraActions.getCategoryPublicCreditBalance.rejected, (state, action) => {
      state.categorycreditBalance = { error: action.error };
    })

    // Reducer for - Insert / Update public user send Message
    .addCase(
      extraActions.InsertUpdateMessageCommunicationSent.pending,
      (state) => {
        //  state.sendMessageStatus = { loading: true };
      }
    )
    .addCase(
      extraActions.InsertUpdateMessageCommunicationSent.fulfilled,
      (state, action) => {
        //   state.sendMessageStatus = action.payload;
      }
    )
    .addCase(
      extraActions.InsertUpdateMessageCommunicationSent.rejected,
      (state, action) => {
        //  state.sendMessageStatus = { error: action.error };
      }
    )

    // Reducer for - Insert / Update public user send (Photo)
    .addCase(
      extraActions.InsertUpdatePhotoCommunicationSent.pending,
      (state) => {
        state.sendMessageStatus = { loading: true };
      }
    )
    .addCase(
      extraActions.InsertUpdatePhotoCommunicationSent.fulfilled,
      (state, action) => {
        state.sendMessageStatus = action.payload;
      }
    )
    .addCase(
      extraActions.InsertUpdatePhotoCommunicationSent.rejected,
      (state, action) => {
        state.sendMessageStatus = { error: action.error };
      }
    )

    // Reducer for - Insert / Update public user send (Photo)
    .addCase(
      extraActions.InsertUpdateEcardCommunicationSent.pending,
      (state) => {
        state.sendMessageStatus = { loading: true };
      }
    )
    .addCase(
      extraActions.InsertUpdateEcardCommunicationSent.fulfilled,
      (state, action) => {
        state.sendMessageStatus = action.payload;
      }
    )
    .addCase(
      extraActions.InsertUpdateEcardCommunicationSent.rejected,
      (state, action) => {
        state.sendMessageStatus = { error: action.error };
      }
    )

    // Reducer for - Save message as draft
    .addCase(extraActions.DraftMessageCUD.pending, (state) => {
      //  state.saveDraftStatus = { loading: true };
    })
    .addCase(extraActions.DraftMessageCUD.fulfilled, (state, action) => {
      //   state.saveDraftStatus = action.payload;
    })
    .addCase(extraActions.DraftMessageCUD.rejected, (state, action) => {
      //  state.saveDraftStatus = { error: action.error };
    })

    // Reducer for - Details
    .addCase(extraActions.GetDraftMessageDetails.pending, (state) => {
      //  state.saveDraftStatus = { loading: true };
    })
    .addCase(extraActions.GetDraftMessageDetails.fulfilled, (state, action) => {
      //   state.saveDraftStatus = action.payload;
    })
    .addCase(extraActions.GetDraftMessageDetails.rejected, (state, action) => {
      //  state.saveDraftStatus = { error: action.error };
    })

    // Load E-Cards
    // Reducer for - Details
    .addCase(extraActions.LoadECard.pending, (state) => {
      state.ecardImages = null; // Set to `null` during loading
    })
    .addCase(extraActions.LoadECard.fulfilled, (state, action) => {
      state.ecardImages = action.payload;
    })
    .addCase(extraActions.LoadECard.rejected, (state, action) => {
      state.ecardImages = [];
    })

    // Load Keywords
    // Reducer for - Details
    // .addCase(extraActions.LoadKeywordList.pending, (state) => {})
    // .addCase(extraActions.LoadKeywordList.fulfilled, (state, action) => {})
    // .addCase(extraActions.LoadKeywordList.rejected, (state, action) => {})

    // Reducer for Load E-card category List
    .addCase(extraActions.LoadEcardCategoryList.pending, (state) => {
      state.ecardCategoryList = null; // Set to `null` during loading
    })
    .addCase(extraActions.LoadEcardCategoryList.fulfilled, (state, action) => {
      state.ecardCategoryList = action.payload;
    })
    .addCase(extraActions.LoadEcardCategoryList.rejected, (state, action) => {
      state.ecardCategoryList = [];
    })

    // Reducer for Load E-card List
    .addCase(extraActions.LoadEcardList.pending, (state) => {
      state.ecardList = null; // Set to `null` during loading
    })
    .addCase(extraActions.LoadEcardList.fulfilled, (state, action) => {
      state.ecardList = action.payload;
    })
    .addCase(extraActions.LoadEcardList.rejected, (state, action) => {
      state.ecardList = [];
    })

    // Reducer for Load E-card List
    .addCase(extraActions.LoadEcardForPublicUserDetails.pending, (state) => {
      state.ecardInfo = null; // Set to `null` during loading
    })
    .addCase(
      extraActions.LoadEcardForPublicUserDetails.fulfilled,
      (state, action) => {
        state.ecardInfo = action.payload;
      }
    )
    .addCase(
      extraActions.LoadEcardForPublicUserDetails.rejected,
      (state, action) => {
        state.ecardInfo = [];
      }
    )

    // Reducer for Load E-card - Inmate List
    .addCase(extraActions.LoadPublicMyContactsDisplayEcard.pending, (state) => {
      state.inmateList = null; // Set to `null` during loading
    })
    .addCase(
      extraActions.LoadPublicMyContactsDisplayEcard.fulfilled,
      (state, action) => {
        state.inmateList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadPublicMyContactsDisplayEcard.rejected,
      (state, action) => {
        state.inmateList = [];
      }
    )

    // Reducer for Load E-card - Inmate List based get facility cost and category cost
    .addCase(extraActions.LoadPublicMyContactsDisplayForEcardDetails.pending, (state) => {
      state.ecardInmateInfo = null; // Set to `null` during loading
    })
    .addCase(
      extraActions.LoadPublicMyContactsDisplayForEcardDetails.fulfilled,
      (state, action) => {
        state.ecardInmateInfo = action.payload;
      }
    )
    .addCase(
      extraActions.LoadPublicMyContactsDisplayForEcardDetails.rejected,
      (state, action) => {
        state.ecardInmateInfo = [];
      }
    )


    // Reducer For Send E-card
    .addCase(extraActions.SendEcardFromPublicUser.pending, (state) => {
      state.sendEcardStatus = null; // Set to `null` during loading
    })
    .addCase(
      extraActions.SendEcardFromPublicUser.fulfilled,
      (state, action) => {
        state.sendEcardStatus = action.payload;
      }
    )
    .addCase(
      extraActions.SendEcardFromPublicUser.rejected,
      (state, action) => {
        state.sendEcardStatus = [];
      }
    );
}
